import { FieldOptions, Profile } from "../../../../app/user/profile/profileUtils";

/**
 * Adds an option object to a specific field within a field group in the JSON object.
 * @param {Object} jsonObject - The original JSON object.
 * @param {string} fieldGroup - The name of the field group.
 * @param {string} field - The name of the field within the field group.
 * @param {Object} optionToAdd - The option object to add.
 * @returns {Object} - The updated JSON object with the new option added.
 */
export const addOptionToFieldInGroup = (jsonObject: Profile, fieldGroup: string, field: string, options: FieldOptions[]) => {
  // Create a deep copy of the profile object
  const updatedObject = {
    ...jsonObject,
    fieldGroups: {
      ...jsonObject.fieldGroups,
      [fieldGroup]: {
        ...jsonObject.fieldGroups?.[fieldGroup],
        fields: {
          ...jsonObject.fieldGroups?.[fieldGroup]?.fields,
          [field]: {
            ...jsonObject.fieldGroups?.[fieldGroup]?.fields?.[field],
            options: [
              ...(jsonObject.fieldGroups?.[fieldGroup]?.fields?.[field]?.options || []), // Preserve existing options
              ...options, // Add new options
            ],
          },
        },
      },
    },
  };

  return updatedObject;
};

